import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-arrears-form',
  templateUrl: './payment-arrears-form.component.html',
  styleUrls: ['./payment-arrears-form.component.css']
})
export class PaymentArrearsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-arrears/payment-arrears-form/payment-arrears-form.component.ts